import { inject, Service } from '@angular/core';

import { SessionService } from '@advania-cosoftware/wolf-core';

export const homeSegments = {
    home: 'home',
} as const;

const homeRoutes = {
    base: [homeSegments.home],
};

@Service()
export class HomeRouter {
    private readonly _sessionService = inject(SessionService);

    public getHomeRoute(): string[] {
        return ['/', this._sessionService.activeCustomerNumber(), ...homeRoutes.base];
    }
}
